import React from 'react';
import '../../styles/App.css';
import QueueReportsList from '../../features/queues/QueueReportsList';

function QueuesReportsPage() {
  return (
    <div className="Reports-Page-Container">
        <QueueReportsList />
    </div>
  );
}

export default QueuesReportsPage;